import React, { useRef, useEffect, useState, useContext } from "react";
import {
  View,
  Text,
  Image,
  TouchableOpacity,
  Animated,
  Alert,
  ScrollView,
} from "react-native";
import { useColorScheme } from "react-native-appearance";
import { colors } from "../context/Colors";
import * as Animatable from "react-native-animatable";
import { CountUp } from "use-count-up";
import AppContext from "../context";
import RewardRules from "./RewardRules";

const medals = {
  gold: {
    color: "#FDC82A",
    image: require("../assets/medal-gold.png"),
  },
  wood: {
    color: "#9E5A23",
    image: require("../assets/medal-wooden.png"),
  },
  stone: {
    color: "#9E9E9E",
    image: require("../assets/medal-stone.png"),
  },
  bronze: {
    color: "#E89C4F",
    image: require("../assets/medal-bronze.png"),
  },
  silver: {
    color: "#C6C7C7",
    image: require("../assets/medal-silver.png"),
  },
};

const whichMedal = (percent) => {
  if (percent <= 0.2) return "wood";
  if (percent > 0.2 && percent <= 0.4) return "stone";
  if (percent > 0.4 && percent <= 0.6) return "bronze";
  if (percent > 0.6 && percent <= 0.8) return "silver";
  if (percent > 0.8) return "gold";
};

export default function FinalAnimation({
  cancel,
  inStats,
  share,
  captureText,
  captureTextTop,
}) {
  const { tour, dict } = useContext(AppContext);
  const theme = useColorScheme() === "dark" ? "dark" : "light";
  const [keyFrame, setKeyFrame] = useState(inStats ? 20 : 1);
  const possibleScore = tour.totalPossibleScore;
  const score = tour.totalScore;
  const medal = whichMedal(score / possibleScore);

  const widthAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (!inStats) {
      setTimeout(() => {
        setKeyFrame(2);
      }, 3000);
      setTimeout(() => {
        setKeyFrame(10);
        Animated.timing(widthAnim, {
          toValue: score,
          duration: 3500,
          useNativeDriver: false,
        }).start();
      }, 3200);
      setTimeout(() => {
        setKeyFrame(30);
      }, 6500);
    }
  }, []);

  return (
    <ScrollView>
      {keyFrame < 10 ? (
        <Animatable.View
          style={{ alignItems: "center" }}
          animation={keyFrame === 1 ? "bounceIn" : "bounceOut"}
        >
          <Text
            style={{
              fontSize: 19,
              textAlign: "center",
              color: colors[theme].text,
              marginBottom: 10,
              fontWeight: "600",
            }}
          >
            {dict.congratulations}
          </Text>
          <Text
            style={{
              fontSize: 16,
              textAlign: "center",
              color: colors[theme].text,
              opacity: 0.4,
            }}
          >
            {dict.finished_game}
          </Text>
          <Image
            source={require("../assets/conffeti-end-game-static.png")}
            style={{ width: 235, height: 263, marginTop: 20 }}
          />
          <Image
            source={require("../assets/conffeti-end-game.gif")}
            style={{
              width: 230,
              height: 230,
              marginTop: 40,
              left: 70,
              position: "absolute",
            }}
          />
        </Animatable.View>
      ) : null}
      {keyFrame > 9 ? (
        <Animatable.View
          style={{ alignItems: "center" }}
          animation={"bounceIn"}
        >
          <Text
            style={{
              color: colors[theme].text,
              textAlign: "center",
              margin: 10,
            }}
          >
            {captureTextTop}
          </Text>
          {!inStats && !captureText && (
            <Text
              style={{
                fontSize: 19,
                textAlign: "center",
                color: colors[theme].text,
                marginBottom: 10,
                fontWeight: "600",
              }}
            >
              {dict.you_won}
            </Text>
          )}
          {keyFrame < 19 ? (
            <Image
              source={require("../assets/medal-empty.png")}
              style={{ width: 253, height: 245, marginTop: inStats ? 0 : 20 }}
            />
          ) : null}
          {keyFrame > 19 ? (
            <Animatable.Image
              source={medals[medal].image}
              style={{
                width: 277,
                height: 276,
                marginTop: inStats ? 0 : 20,
              }}
              animation={"bounceIn"}
            />
          ) : null}
          {keyFrame > 19 ? (
            <Image
              source={require("../assets/conffeti-end-game.gif")}
              style={{
                width: 277,
                height: 276,
                marginTop: inStats ? 20 : 40,
                position: "absolute",
              }}
            />
          ) : null}
          {keyFrame > 19 ? (
            <Animatable.View animation={"bounceIn"}>
              <Text
                style={{
                  color: medals[medal].color,
                  fontWeight: "bold",
                  fontSize: 24,
                  marginTop: 20,
                }}
              >
                {dict.medals[medal].name}!
              </Text>
              <Text
                style={{
                  fontSize: 16,
                  textAlign: "center",
                  color: colors[theme].text,
                  opacity: 0.4,
                }}
              >
                {dict.level_achieved}
              </Text>
            </Animatable.View>
          ) : null}
          <Text
            style={{
              color: "#26C97A",
              fontWeight: "bold",
              fontSize: 64,
              marginTop: 10,
            }}
          >
            <CountUp
              isCounting={keyFrame > 1}
              end={score}
              duration={inStats ? 0 : 3}
              thousandsSeparator={" "}
              onComplete={() => setKeyFrame(inStats ? 30 : 20)}
            />
          </Text>
          <Text
            style={{
              fontSize: 16,
              textAlign: "center",
              color: colors[theme].text,
              opacity: 0.4,
            }}
          >
            {captureText ? dict.my_final_score : dict.your_final_score}
          </Text>
          {!inStats && !captureText && (
            <View>
              <Image
                source={require("../assets/bar-empty.png")}
                style={{ width: 288, height: 24, marginTop: 20 }}
              />
              <Animated.View
                style={{
                  position: "absolute",
                  width: widthAnim.interpolate({
                    inputRange: [0, possibleScore],
                    outputRange: ["0%", "100%"],
                  }),
                  overflow: "hidden",
                }}
              >
                <Image
                  source={require("../assets/bar-full.png")}
                  style={{ width: 288, height: 24, marginTop: 20 }}
                />
              </Animated.View>
            </View>
          )}
        </Animatable.View>
      ) : null}
      {keyFrame > 20 ? (
        <>
          {captureText ? (
            <View />
          ) : (
            <Animatable.View animation={"bounceIn"}>
              <TouchableOpacity
                style={{
                  borderColor: "#26C97A",
                  borderWidth: 2,
                  borderRadius: 4,
                  alignItems: "center",
                  padding: 10,
                  marginTop: 20,
                }}
                onPress={() => share()}
              >
                <Text style={{ color: "#26C97A", fontSize: 18 }}>
                  {dict.share_your_score}
                </Text>
              </TouchableOpacity>
            </Animatable.View>
          )}
          {!inStats && !captureText && (
            <>
              <Animatable.View animation={"bounceIn"} delay={300}>
                <TouchableOpacity
                  style={{
                    alignItems: "center",
                    padding: 5,
                    marginTop: 20,
                  }}
                  onPress={() => cancel()}
                >
                  <Text style={{ color: "#26C97A", fontSize: 18 }}>
                    {dict.continue}
                  </Text>
                </TouchableOpacity>
              </Animatable.View>
              <RewardRules rules={tour.rewardRules} />
            </>
          )}
        </>
      ) : null}
    </ScrollView>
  );
}
